import * as React from 'react';
import { Combobox } from '@/components/ui/combobox';
import { DatePickerFilter } from '@/components/common/date-picker';
import { useFilters } from '@/hooks';
import { format, parseISO, parse, isValid } from 'date-fns';

export const DateFilter = () => {
	const [open, setOpen] = React.useState(false);
	const { setParamSeveralFilters, query, clearSpecificFilters, hasFilter } =
		useFilters();

	const dateFrom = query['dateFrom'] as string;
	const dateTo = query['dateTo'] as string;
	const sort = query['sort'] as string;

	const initialFrom = React.useMemo(() => {
		if (!dateFrom) return '';
		const date = parse(dateFrom, 'MM-dd-yyyy', new Date());
		if (isValid(date)) return format(date, 'MM-dd-yyyy');
		const isoDate = parseISO(dateFrom);
		if (isValid(isoDate)) return format(isoDate, 'MM-dd-yyyy');
		return '';
	}, [dateFrom]);

	const initialTo = React.useMemo(() => {
		if (!dateTo) return '';
		const date = parse(dateTo, 'MM-dd-yyyy', new Date());
		if (isValid(date)) return format(date, 'MM-dd-yyyy');
		const isoDate = parseISO(dateTo);
		if (isValid(isoDate)) return format(isoDate, 'MM-dd-yyyy');
		return '';
	}, [dateTo]);

	const handleApply = (
		from: string | undefined,
		to: string | undefined,
		sort: string | undefined
	) => {
		setParamSeveralFilters([
			{
				label: 'dateFrom',
				value: from
					? format(parse(from, 'MM-dd-yyyy', new Date()), 'yyyy-MM-dd')
					: undefined,
			},
			{
				label: 'dateTo',
				value: to
					? format(parse(to, 'MM-dd-yyyy', new Date()), 'yyyy-MM-dd')
					: undefined,
			},
			{
				label: 'sort',
				value: sort,
			},
		]);
		setOpen(false);
	};

	return (
		<Combobox
			open={open}
			setOpen={setOpen}
			placeholder="Date"
			options={[]}
			classNamePopoverContent="!w-fit !p-0 border-none shadow-shadow2 rounded-lg"
			classNameButton="h-[33px] rounded-lg border-smoke-50 !w-[118px]"
			hasValue={
				hasFilter('dateFrom') ||
				hasFilter('dateTo') ||
				['STATUS_DATE_ASC', 'STATUS_DATE_DESC'].includes(
					query['sort'] as string
				)
			}
		>
			<DatePickerFilter
				initialFrom={initialFrom}
				initialTo={initialTo}
				initialSort={sort}
				onApply={(data) => handleApply(data.from, data.to, data.sort)}
				onCancel={() => setOpen(false)}
				onClearAll={() => {
					clearSpecificFilters(['dateFrom', 'dateTo', 'sort']);
					setOpen(false);
				}}
			/>
		</Combobox>
	);
};
